import React from 'react';

import styles from './onboardingFormStyles.scss';

import OnboardingWatchlistForm from './OnboardingWatchlistForm/onboardingWatchlistForm';
import OnboardingTickersForm from './OnboardingTickersForm/onboardingTickersForm';
import OnboardingCommunityForm from './OnboardingCommunityForm/onboardingCommunityForm';

const onboardingForm = ({ page, handleSubmit, goToPage, watchlist, isAllocator }) => {
  return (
    <div className={styles.onboardingFormContainer} id="onboarding-form">
      <div className={styles.onboardingForm}>
        {page > 1 && (
          <div className={styles.backSection}>
            <span className={styles.backButton} onClick={() => goToPage(page - 1)}>
              {'<<'} Back to Previous Section
            </span>
          </div>
        )}
        {(!page || page === 1) && (
          <OnboardingWatchlistForm
            handleSubmit={handleSubmit}
            watchlist={watchlist}
            isAllocator={isAllocator}
          />
        )}
        {page === 2 && <OnboardingTickersForm handleSubmit={handleSubmit} watchlist={watchlist} />}
        {page === 3 && (
          <OnboardingCommunityForm
            handleSubmit={handleSubmit}
            isAllocator={isAllocator}
            watchlist={watchlist}
          />
        )}
      </div>
      <div className={styles.copywrite}>
        © {new Date().getFullYear()} SumZero, Inc. | All Rights Reserved
      </div>
    </div>
  );
};

export default onboardingForm;
